import React from 'react';
import { Description } from '../../components/layouts';
import './style.scss';
import { getTrack } from '../../helpers';

const track = getTrack({ block: 29 });

export function Remarks() {
  return (
    <div className="page-section section-remarks inverted" data-track={track}>
      <div className="section-content">
        {/*<Description className="caption">备注：</Description>*/}
        <ol>
          <li>1、X60 Pro+超广角微云台镜头的视场范围约为X60 Pro主摄的3倍。</li>
          <li>2、对比X50 Pro+主摄，X60 Pro+的5000万像素超大底主摄感光度最高提升140%。</li>
          <li>3、对比X50 Pro+，X60 Pro+超清夜景视频综合感光度提升300%。</li>
          <li>4、由于手机系统和预装的程序占据了部分运存空间，实际运存空间少于 12GB。另外8GB运存版本可选。</li>
          <li>5、Powered by Multi-Turbo。</li>
          <li>6、重度应用场景下，对比不配备内存融合技术的机器，X60 Pro+系统后台保活能力提升 58%、运存使用效率提升37%。</li>
          <li>7、对比上一代X50 Pro+，X60 Pro+随机写入速度提升14%，数据会因存储配置不同存在差异。</li>
          <li>8、X60 Pro+搭配 vivo 官方标配充电器（闪充电源适配器 11V/5A），最大可支持 55W 闪充；实际充电功率会随场景变化而动态调节，请以实际使用情况为准。</li>
          <li>9、页面内的手机外观示意图、内部结构图及产品效果仅供参考，实际可能因光线环境、生产批次的不同，存在颜色、丝印等细节差异，请以实物为准。</li>
          <li>10、以上页面的数据及参数为我司实验室标准环境下的测试结果，部分数据为峰值数据，数据及参数的实际情况会因测试环境、测试软件等不同略有差异。</li>
          <li>11、不同拍摄模式的像素可能存在差异，部分样张大小经过裁剪，仅供参考，请以实际拍摄效果为准。</li>
          <li>12、由于产品的某些规格、参数、零部件、外观细节（例如：电池盖有无丝印）可能因供应商更换或生产批次等原因发生变化，vivo 将根据调整实时更新页面内的描述，请仔细查看。</li>
          <li>13、X60 Pro+ 使用第三方贴膜会影响屏幕指纹识别效果，请务必使用“vivo 屏幕指纹官方定制膜”。请注意贴膜时不能覆盖听筒微缝，贴 3D 钢化膜使用胶水时，不要流入受话器微缝及侧按键里面。</li>
          <li>14、屏幕尺寸为按照标准矩形测量的屏幕直角对角线的长度，实际可视区域略小。</li>
          <li>15、本产品 5G 网络支持 SA & NSA 模式，SA 支持能力取决于可用的网络和软件版本；5G 网络具体组网情况及网络覆盖范围，以运营商实际部署为准。</li>
          <li>16、ZEISS，ZEISS标识，是卡尔蔡司的注册商标。</li>
          <li>17、素皮自身带有轻微色差、痕迹和纹理属于正常现象；素皮电池盖请避免接触肥皂、酒精等腐蚀性溶剂；出现轻微污渍时，可用湿布蘸取PH值中性的皮革专用清洁剂擦拭。</li>
          <li>18、X60 Pro+镜头部分镜片为复合多层镀膜、部分为纳米晶体结构镀膜。</li>
        </ol>
      </div>
    </div>
  );
}
